import { jsPDF } from "jspdf";

export const MAX_HEADLINE_WIDTH = 3241;

export function truncateTextToWidth(pdf: jsPDF, text: string, maxWidth: number): string {
  if (pdf.getTextWidth(text) <= maxWidth) {
    return text;
  }
  const ellipsis = "…";
  let truncated = text;
  while (truncated.length > 0 && pdf.getTextWidth(truncated + ellipsis) > maxWidth) {
    truncated = truncated.slice(0, -1);
  }
  return truncated + ellipsis;
}
